import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchCandidateList, verifyCandidate } from "./CandidateDataAPI"

const initialState = {
  data: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  loading: false,
  error: null,
}

export const fetchCandidateDataasync = createAsyncThunk("candidatedata/fetch", async (page, { rejectWithValue }) => {
  try {
    return await fetchCandidateList(page)
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const verifyCandidateAsync = createAsyncThunk(
  "candidate/verify",
  async ({ uuid, verifyData }, { rejectWithValue }) => {
    try {
      const response = await verifyCandidate(uuid, verifyData)
      return { uuid, ...response }
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const CandidateDataSlice = createSlice({
  name: "candidateData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateDataasync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCandidateDataasync.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.candidates
        state.pagination = action.payload.pagination
      })
      .addCase(fetchCandidateDataasync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(verifyCandidateAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(verifyCandidateAsync.fulfilled, (state, action) => {
        state.loading = false
        const updatedCandidate = action.payload
        state.data = state.data.map((candidate) =>
          candidate.uuid === updatedCandidate.uuid ? { ...candidate, is_verified: true } : candidate,
        )
      })
      .addCase(verifyCandidateAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const selectCandidateData = (state) => state.candidateData.data
export const selectPagination = (state) => state.candidateData.pagination

export default CandidateDataSlice.reducer

